import React from 'react';
import './AboutSchool.css'; // Import the CSS file
import {useEffect} from 'react';

function AboutSchool() {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []); 
  return (
    <div className="about-container">
      <h2 className="about-heading">About Us</h2>
      <p className="about-paragraph">
        Welcome to Oxford Convent English Medium School, a distinguished
        institution dedicated to providing quality education under the Karnataka
        State Board curriculum. Located in a serene environment, our school is
        committed to nurturing young minds with a focus on holistic development
        and lifelong learning.
      </p>

      <div className="section">
        <h3 className="section-heading">Academic Excellence</h3>
        <p className="about-paragraph">
          Our school follows the Karnataka State Board syllabus, ensuring a
          comprehensive and structured academic framework. This curriculum is
          designed to equip students with a strong foundation in core subjects
          while encouraging analytical thinking, problem-solving, and
          creativity. Our highly qualified and dedicated faculty members employ
          innovative teaching methodologies to make learning engaging and
          impactful.
        </p>
      </div>

      <div className="section">
        <h3 className="section-heading">Co-Curricular and Extracurricular Activities</h3>
        <p className="about-paragraph">
          At Oxford Convent English Medium School, we believe that education
          goes beyond textbooks. To promote all-round development, we offer a
          wide range of co-curricular and extracurricular activities, including:
        </p>
        <ul className="list">
          <li>Sports and physical education to foster teamwork, discipline, and fitness.</li>
          <li>Arts, music, and drama to nurture creativity and self-expression.</li>
          <li>Science clubs, debates, and quizzes to encourage curiosity and intellectual growth.</li>
        </ul>
      </div>

      <div className="section">
        <h3 className="section-heading">Values-Based Education</h3>
        <p className="about-paragraph">
          Our school places a strong emphasis on values such as respect,
          integrity, and empathy. We aim to instill these qualities in our
          students, preparing them to be responsible citizens who contribute
          positively to society.
        </p>
      </div>

      <div className="section">
        <h3 className="section-heading">Modern Infrastructure and Resources</h3>
        <p className="about-paragraph">
          Our campus is equipped with state-of-the-art facilities, including:
        </p>
        <ul className="list">
          <li>Well-ventilated classrooms conducive to effective learning.</li>
          <li>Science and computer laboratories to provide hands-on learning experiences.</li>
          <li>A well-stocked library to foster a love for reading and research.</li>
          <li>Playgrounds and sports facilities to encourage physical fitness.</li>
        </ul>
      </div>

      <div className="section">
        <h3 className="section-heading">Inclusive and Supportive Environment</h3>
        <p className="about-paragraph">
          We are dedicated to creating an inclusive atmosphere where every
          student feels valued and supported. Our experienced faculty members
          offer personalized attention to cater to the unique needs of each
          learner.
        </p>
      </div>

      <div className="section">
        <h3 className="section-heading">Community Engagement</h3>
        <p className="about-paragraph">
          We actively collaborate with parents and the community to create a
          strong support system for our students. Regular parent-teacher
          interactions and community initiatives ensure holistic growth and a
          shared commitment to excellence.
        </p>
      </div>

      <p className="about-paragraph concluding-paragraph">
          Join us at Oxford Convent English Medium School as we strive to shape
          confident, knowledgeable, and compassionate individuals ready to excel
          in life and contribute meaningfully to the world.
        </p>
    </div>
  );
}

export default AboutSchool;